import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

function LoginScreen() {
  const { login } = useAuth();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(password);
    } catch (err) {
      setError(err.message || 'Invalid password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.brand}>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#0d9488" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <path d="M9 15l2 2 4-4"></path>
          </svg>
          <h1 style={styles.title}>DocTriage</h1>
          <p style={styles.subtitle}>AI-Powered Document Analysis & Q&A</p>
        </div>

        <form onSubmit={handleSubmit} style={styles.form}>
          <input
            type="password"
            placeholder="Enter team password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
            autoFocus
            disabled={loading}
          />
          <button
            type="submit"
            disabled={loading || !password}
            style={{
              ...styles.button,
              opacity: (loading || !password) ? 0.6 : 1,
            }}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
          {error && <div style={styles.error}>{error}</div>}
        </form>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #0d9488 0%, #0f766e 50%, #115e59 100%)',
  },
  card: {
    background: 'white',
    borderRadius: '12px',
    padding: '48px 40px',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15)',
    width: '100%',
    maxWidth: '400px',
    textAlign: 'center',
  },
  brand: {
    marginBottom: '32px',
  },
  title: {
    margin: '12px 0 4px',
    fontSize: '1.75rem',
    fontWeight: 700,
    color: '#0f766e',
  },
  subtitle: {
    margin: 0,
    fontSize: '0.875rem',
    color: '#64748b',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  input: {
    padding: '12px 16px',
    fontSize: '1rem',
    border: '1px solid #cbd5e1',
    borderRadius: '8px',
    outline: 'none',
    transition: 'border-color 0.2s',
  },
  button: {
    padding: '12px',
    fontSize: '1rem',
    fontWeight: 600,
    color: 'white',
    background: 'linear-gradient(135deg, #0d9488 0%, #0f766e 100%)',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'opacity 0.2s',
  },
  error: {
    color: '#dc2626',
    fontSize: '0.875rem',
    marginTop: '4px',
  },
};

export default LoginScreen;
